import React from 'react'

function Spinner() {
  return (
    <div>
      Loading...
    </div>
  )
}

export default Spinner